import { FontAsset, KeyedFontAsset } from '../stores/types/font-assets';

// theme fonts persist as font-1/font-2/font-3, but a handful of templates
// (every countdown, the mondrian outro) name the field 'font'. Those themes can
// carry both keys, so the canonical one wins — the bare key may be a stale row
// written before writes were normalized.
const themeFontKeys = (userData: string, index: number): string[] => (
	userData.startsWith('font-') ? [userData] : [`font-${index + 1}`, userData]
);

export const resolveThemeFont = (
	fonts: KeyedFontAsset,
	userData: string,
	index: number,
): FontAsset | null => (
	themeFontKeys(userData, index)
		.map((key) => fonts[key])
		.find((font) => !!font?.url) ?? null
);

export const canonicalThemeFontKey = (userData: string, index: number): string => (
	userData.startsWith('font-') ? userData : `font-${index + 1}`
);
